<div class="footer-wrapper">
  <div class="section-width">
    <div
      *ngFor="let child of (footerSection$ | async)?.content?.children"
      class="footer-content"
      [innerHTML]="child?.body | safeHtml"
    ></div>
    <div class="footer-links">
      <ul
        class="footer-links__list"
        [class.footer-links__list-image]="'custom_footer_image_overlay' | customImage | async"
      >
        <ng-container *ngFor="let menu of footerMenuList$ | async">
          <li *ngIf="menu.isVisible" class="footer-links__list-item">
            <a
              href
              role="link"
              tabindex="0"
              class="footer__menu__a"
              [routerLink]="menu.routerLink"
              (accessibleClick)="navigate(menu.routerLink)"
            >
              {{ menu?.customName ? menu?.customName : (menu.translate | translate) }}
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div *ngIf="showPlatformProvider">
      <div *ngIf="platformProviderType === 'provider' && isAccessHrt" class="platform-provider">
        <div class="platform-provider__text" [translate]="'GlobalNav:ServiceProvidedBy'">Service provided by</div>
        <div role="img" class="platform-provider-footer-icon" [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"></div>
      </div>

      <div *ngIf="platformProviderType === 'delivered'" class="platform-provider">
        <div class="platform-provider__text" [translate]="'GlobalNav:DeliveredBy'">Delivered by Ten</div>
      </div>

      <div *ngIf="platformProviderType === 'partnership'" class="platform-provider">
        <div class="platform-provider__text" [translate]="'GlobalNav:InPartnerShipWith'">In partnership with</div>
        <div role="img" class="platform-provider-footer-icon" [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"></div>
      </div>
    </div>
  </div>
</div>
